import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import * as React from "react";
import MenuBar from "components/mnl/global/menuBar";
import { theme } from "components/mnl/global/theme";
import V2sessionTimeout from "components/mnl/global/v2SessionTimeout";
import TableLayout from "views/mnl/layout/tableLayout";
import AuthenticateExternalSystemCredentials from "components/mnl/externalSystemCredential/authenticateExternalSystemCredentials";

const ExternalSystemCredentialPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <MenuBar pageName={"External System Credential"} />
        <TableLayout>
          <AuthenticateExternalSystemCredentials />
        </TableLayout>
      </Box>
      <V2sessionTimeout />
    </ThemeProvider>
  );
};
export default ExternalSystemCredentialPage;
